import {css} from "@emotion/react";
import React from "react";

type LineFlexRateType = 'center' | 'aLittleLeft';

const TypeToFlex: Record<LineFlexRateType, number> = {
  center: 1,
  aLittleLeft: 0.95,
};
const TitleWithLinesStyle = (shiftLeft: boolean) => css`
  display: flex;
  align-items: center;
  gap: ${shiftLeft ? '8px' : '16px'};
  width: 100%;
`;

const LineStyle = (flexValue: number) => css`
    width: 100%; 
    border-top: 1px solid #ccc;
    flex: ${flexValue};
`;

const TitleTextStyle = css`
  white-space: nowrap;
  font-size: 20px;
  font-weight: bold;
  color: #444;
`;

const ContentHeader = (
    { title, iconPath='', shiftLeft = false, lineFlexRate = 'center'}:
    { title: string; iconPath?: string; shiftLeft?: boolean; lineFlexRate?: LineFlexRateType }
) => {
  const leftFlex = TypeToFlex[lineFlexRate];
  const rightFlex = shiftLeft ? 1.7 : 1;

  return (
      <div css={TitleWithLinesStyle(shiftLeft)}>
        <div css={LineStyle(leftFlex)} />
        <img src={iconPath} alt={title} />
        <h2 css={TitleTextStyle}>{title}</h2>
        <div css={LineStyle(rightFlex)} />
      </div>
  );
};

export default ContentHeader;
